"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var TransactionSearchResultsTableRow_1 = require("./TransactionSearchResultsTableRow");
var TransactionSearchResultsTable = /** @class */ (function (_super) {
    __extends(TransactionSearchResultsTable, _super);
    function TransactionSearchResultsTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionSearchResultsTable.prototype.render = function () {
        return this.props.transactions && this.props.transactions.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "col-12 table-responsive", children: (0, jsx_runtime_1.jsxs)("table", { className: "table table-striped table-hover table-sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Transaction date" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Amount" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Card Number" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Policy number" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Invoice ID" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Actions" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderSearchResultRows() })] }) }));
    };
    TransactionSearchResultsTable.prototype.renderSearchResultRows = function () {
        return this.props.transactions.map(function (transaction, index) {
            return (0, jsx_runtime_1.jsx)(TransactionSearchResultsTableRow_1.TransactionSearchResultsTableRow, { transaction: transaction }, index);
        });
    };
    TransactionSearchResultsTable = __decorate([
        components_1.authorize
    ], TransactionSearchResultsTable);
    return TransactionSearchResultsTable;
}(React.Component));
exports.default = TransactionSearchResultsTable;
//# sourceMappingURL=TransactionSearchResultsTable.js.map